<template>
    <div class="grid gap-2">
        <div class="flex items-center justify-between">
            <v-btn-toggle
                v-model="currentTab"
                @change="getList()"
            >
                <template v-for="item in menu">
                    <v-btn
                        :key="item.text"
                        :value="item.value"
                    >
                        {{ item.text }}
                    </v-btn>
                </template>
            </v-btn-toggle>
            <v-dialog
                v-model="dialogVisible"
                max-width="600"
                persistent
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        color="primary"
                        v-on="on"
                        @click="formData.grade = currentTab"
                    >
                        新增項目
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <template>
                    <v-card class="p-5">
                        <v-form
                            ref="form"
                            lazy-validation
                        >
                            <v-select
                                v-model="formData.grade"
                                :items="menu.filter((item) => item.value)"
                                :rules="emptyRule"
                                item-text="text"
                                item-value="value"
                                label="選擇年級"
                                outlined
                            />
                            <v-select
                                v-model="formData.subject"
                                :items="subjects.filter((item) => item.value)"
                                :rules="emptyRule"
                                item-text="text"
                                item-value="value"
                                label="科目"
                                outlined
                            />
                            <div
                                v-if="formData.subject!=='命題範圍'"
                                class="mb-5"
                            >
                                <strong class="mb-2 block">考試範圍(條列)</strong>
                                <ol>
                                    <li
                                        v-for="(item, i) in formData.examScopeList"
                                        :key="i"
                                    >
                                        <div class="flex items-center">
                                            <v-text-field
                                                v-model="formData.examScopeList[i]"
                                                :rules="emptyRule"
                                                outlined
                                                label=""
                                            />
                                            <v-btn
                                                dark
                                                small
                                                rounded
                                                class="ml-2 block mb-7"
                                                @click="formData.examScopeList.splice(i, 1)"
                                            >
                                                刪除
                                            </v-btn>
                                        </div>
                                    </li>
                                </ol>
                                <v-btn
                                    dark
                                    small
                                    rounded
                                    color="primary"
                                    class="ml-auto block"
                                    :disabled="formData.examScopeList.some(scope => !scope)"
                                    @click="formData.examScopeList.push('')"
                                >
                                    新增範圍
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                            <FileUploader
                                v-else
                                v-model="formData.pdfLink"
                                :rules="emptyRule"
                                label="詳細命題範圍PDF檔"
                                accept=".pdf"
                                class="mb-5"
                            />
                        </v-form>
                        <v-card-actions class="justify-end">
                            <v-btn
                                text
                                @click="closeModal()"
                            >
                                取消
                            </v-btn>
                            <v-btn
                                color="primary"
                                @click="handleSubmit()"
                            >
                                儲存
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-dialog>
        </div>
        <v-data-table
            disable-sort
            :items="list"
            :headers="[
                { text: '年級', value: 'grade' },
                { text: '科目', value: 'subject' },
                { text: '', value: 'actions', sortable: false },
            ]"
            :server-items-length="total"
            :options.sync="paginationOptions"
            :footer-props="{
                'items-per-page-options': [5, 10, 50, 100],
            }"
        >
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    small
                    @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MessageBox } from 'element-ui';
import _ from 'lodash';
import FileUploader from '@/components/FileUploader.vue';

const initData = () => ({
    examScopeList: [''],
    weight: 1,
    activity: '',
    grade: '',
    subject: '',
    pdfLink: '',
    id: '',
});

export default {
    components: {
        FileUploader,
    },
    props: {
        activityId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            currentTab: '',
            menu: [
                { text: '全部', value: '' },
                { text: '一年級', value: '一年級' },
                { text: '二年級', value: '二年級' },
                { text: '三年級', value: '三年級' },
                { text: '四年級', value: '四年級' },
                { text: '五年級', value: '五年級' },
                { text: '六年級', value: '六年級' },
            ],
            subjects: [
                { text: '國語', value: '國語' },
                { text: '英文', value: '英文' },
                { text: '數學', value: '數學' },
                { text: '自然', value: '自然' },
                { text: '智力測驗', value: '智力測驗' },
                { text: '命題範圍', value: '命題範圍' },
            ],
            dialogVisible: false,
            formData: initData(),
            emptyRule: [(v) => !!v || '此欄位為必填'],
            paginationOptions: {
                page: 1,
                itemsPerPage: 10,
            },
            total: 0,
            list: [],
        };
    },
    watch: {
        paginationOptions: {
            handler() {
                this.getList();
            },
            deep: true,
        },
    },
    created() {
        this.getList();
    },
    methods: {
        ...mapActions('mScope', ['List', 'Create', 'Delete', 'Update']),
        getList() {
            const { page, itemsPerPage } = this.paginationOptions;
            this.List({
                offset: (page - 1) * itemsPerPage,
                limit: itemsPerPage,
                filter: `activity:${this.activityId};${
                    this.currentTab ? `grade:${this.currentTab}` : ''
                }`,
            }).then((res) => {
                this.list = res.data.raw;
                this.total = res.data.total;
            });
        },
        clearForm() {
            this.formData = initData();
            setTimeout(this.$refs.form.reset, 100);
        },
        closeModal() {
            this.clearForm();
            this.dialogVisible = false;
        },
        handleSubmit() {
            if (this.formData.subject === '命題範圍') {
                this.formData.examScopeList = [' '];
            } else {
                this.formData.pdfLink = ' ';
            }
            if (this.$refs.form.validate()) {
                if (this.formData.id) {
                    this.Update({
                        id: this.formData.id,
                        data: this.formData,
                    })
                        .then(this.getList)
                        .then(this.closeModal);
                } else {
                    this.Create({
                        ...this.formData,
                        activity: this.activityId,
                    })
                        .then(this.getList)
                        .then(this.closeModal);
                }
            }
        },
        editItem(item) {
            _.assign(this.formData, item);
            this.dialogVisible = true;
        },
        deleteItem(item) {
            MessageBox.confirm(`${item.grade}/${item.subject}`, {
                type: 'warning',
                title: '確認刪除？',
                confirmButtonText: '刪除',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.Delete(item.id).then(this.getList);
                })
                .catch(() => {});
        },
    },
};
</script>
